import { render, staticRenderFns } from "./tournament-registration-member-card.vue?vue&type=template&id=fecd6a86&scoped=true&"
import script from "./tournament-registration-member-card.vue?vue&type=script&lang=js&"
export * from "./tournament-registration-member-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecd6a86",
  null
  
)

export default component.exports